import React from 'react';
import jwtDecode from 'jwt-decode';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import { Modal, CheckBoxSelector, Spinner } from 'hyperdb-utils';
import { FILESTORE_URL } from '../../../../../config';

const GalleryTab = ({
  gallery = [], loading = false, propertyId, propertyPictures = [], currentUser,
  toggleModalGallery, showModalGallery = false, selectedPictures = [], onChoosePictures, onAddGalleryPictures,
  onMovePicture, toggleModalRemoveGalleryPicture, showModalRemoveGalleryPicture = false, onRemoveGalleryPicture,
}) => {
  const picturesOptions = () => {
    return propertyPictures
      .filter(picture => !gallery.find(p => p.id === picture.id))
      .filter(picture => picture.original && picture.original.value && picture.thumbnail && picture.thumbnail.value)
      .map(picture => {
        return { name: picture.original.value.name, value: picture.id };
      });
  };

  const getPicture = (pictureId) => {
    return propertyPictures.filter(picture => picture.id === pictureId)[0];
  };

  const pictureUrl = (picture, type) => {
    if (!picture) return '';
    const decoded = jwtDecode(currentUser.jwt);
    const fileId = picture[type] && picture[type].value ? picture[type].value.id : null;
    const fileName = picture[type] && picture[type].value ? picture[type].value.name : null;
    if (fileId && fileName) {
      return `${FILESTORE_URL}/${decoded.client_id}/properties-files/${propertyId}/${fileId}/${fileName}`;
    } else {
      return '';
    }
  };

  return (
    <fieldset>
      <div className="box-header">
        <span>
          <b>Pictures for gallery</b>
          &nbsp;
          <button type="button" className="btn btn-xs btn-primary" onClick={ toggleModalGallery.bind(null, true) }>Add</button>
        </span>
      </div>
      <div className="table-responsive no-padding">
        <table className="table table-hover table-striped table-bordered table-responsive">
          <thead>
            <tr>
              <th>File</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {
              gallery
              // FIXME if a picture is deleted from property, it should be deleted from gallery
              .filter(picture => propertyPictures.find(p => p.id === picture.id))
              .map((galleryPicture, i) => {
                const propertyPicture = getPicture(galleryPicture.id);
                const imgURL = pictureUrl(propertyPicture, 'original');
                const thumbURL = pictureUrl(propertyPicture, 'thumbnail');
                return (
                  <tr key={ i }>
                    <td>
                      {
                        imgURL
                          ? <a href={ imgURL } target="_blank">
                              <img src={ thumbURL } alt="thumbnail" style={{maxWidth: '90px', maxHeight: '60px'}}/>
                            </a>
                          : <img src={ thumbURL } alt="thumbnail" style={{maxWidth: '90px', maxHeight: '60px'}}/>
                      }
                    </td>
                    <td>
                      Filename: { galleryPicture.filename }
                      <br/>
                      {
                        !propertyPicture.original || !propertyPicture.original.value || !propertyPicture.thumbnail || !propertyPicture.thumbnail.value
                          ? <span className="text-danger"><i className="fas fa-warning"/> The picture wasn't uploaded correctly. Please try again.</span>
                          : null
                      }
                    </td>
                    <td>
                      <DropdownButton title={ <span><i className="fas fa-caret" /> Actions</span> } pullRight bsSize="small" id="Menu actions">
                        {
                          i !== 0
                            ? <MenuItem onClick={ onMovePicture.bind(null, 'up', i) }>Up</MenuItem>
                            : null
                        }
                        {
                          i !== gallery.length - 1
                            ? <MenuItem onClick={ onMovePicture.bind(null, 'down', i) }>Down</MenuItem>
                            : null
                        }
                        <MenuItem onClick={ toggleModalRemoveGalleryPicture.bind(null, i) }>Remove</MenuItem>
                      </DropdownButton>
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
      </div>
      {
        showModalGallery
          ? <Modal title="Add pictures to gallery" onClose={ toggleModalGallery.bind(null, false) } onAccept={ onAddGalleryPictures } loading={ loading }>
              <Spinner show={ loading } />
              <CheckBoxSelector
                label="Choose pictures"
                options={ picturesOptions() }
                value={ selectedPictures }
                onChange={ onChoosePictures }
              />
            </Modal>
          : null
      }
      {
        showModalRemoveGalleryPicture
          ? <Modal title="Remove picture" onClose={ toggleModalRemoveGalleryPicture.bind(null, -1) } onAccept={ onRemoveGalleryPicture } loading={ loading }>
              Remove this picture from the gallery ?
            </Modal>
          : null
      }
    </fieldset>
  );
};

export default GalleryTab;



// WEBPACK FOOTER //
// ./src/frontend/modules/content/property-content/components/GalleryTab.jsx